import { Button } from 'antd';

import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { ReactComponent as CheckedSvg } from 'assets/svg-icons/style-checked.svg';

import { STYLED_BTN } from './constants';
const PermissionButton = (props) => {
  const { text, style, type, disabled, ...restProps } = props;

  const renderIconByType = (type) => {
    if (type === 'add') return <PlusOutlined style={{ fontSize: '12px' }} />;

    if (type === 'remove')
      return <MinusOutlined style={{ fontSize: '12px' }} />;

    return <CheckedSvg />;
  };

  const handleBackground = () => {
    if (disabled) return 'grey';

    if (type === 'remove') return 'rgb(232, 81, 84)';

    if (type === 'add') return 'rgb(17, 175, 120)';
  };

  const backgroundColor = handleBackground();

  return (
    <Button
      style={{
        ...STYLED_BTN,
        backgroundColor: backgroundColor,
        cursor: disabled ? 'default' : 'pointer',
        color: 'white',
      }}
      shape='circle'
      className='role-permission-group__title-get-all'
      icon={renderIconByType(type)}
      disabled={disabled}
      {...restProps}
    />
  );
};

export default PermissionButton;
